import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class ProblemSolutionTagMap extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare problemTag: number;
  declare solutionTag: number;

  static get $name() {
    return "ProblemSolutionTagMap";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "problemTag", dataSource: "problem_tag" },
      { name: "solutionTag", dataSource: "solution_tag" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
ProblemSolutionTagMap.exposeProperties();
